<select #comboBox [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [(ngModel)]="selectedPageId" [disabled]="disabled" [hidden]="!visible"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [class.combo-box-required]="required" [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.pageList">
    <option value="{{item.PageId}}">{{item[labelField]}}</option>
  </ng-template>
</select>
